import React from 'react'
import {
  CURRENT_AWARENESS,
  LEGISLATION,
  LEGISLATION_FOLDERS,
  PRECEDENTS_CONTENT,
  QA_CONTENT,
  QA_MENU,
  SEARCH
} from 'constants/controllers'
import FlavourTabs from 'components/tiled-menu/FlavourTabs'
import LegFoldersHeader from 'pages/legislationfolders/Header'
import { PrecedentsTiledMenuHeader } from 'pages/documentscontent/PrecedentsContentHeader'
import LegislationBreadCrumbsContainer from 'redux/containers/pages/legislation/LegislationBreadCrumbsContainer'
import TitleContainer from 'redux/containers/components/qa/TitleContainer'
import { get } from 'libraries/lodash'

const HeaderAppendProxy = ({ controller, url, pageParameters }) => {
  const searchType = url.split('/').slice(-1)[0]
  switch (controller) {
    case QA_MENU:
      return <FlavourTabs isProxy flavours={get(pageParameters, 'flavours', [])} />
    case LEGISLATION_FOLDERS:
      return <LegFoldersHeader isProxy />
    case LEGISLATION:
      return <LegislationBreadCrumbsContainer isProxy />
    case QA_CONTENT:
      return <TitleContainer isProxy />
    case CURRENT_AWARENESS:
      return <div className='min-h3 mt4 mb8-m' />
    case PRECEDENTS_CONTENT:
      return (
        <div className='w-100 pt9'>
          <div className='layout-width-constraint'>
            <PrecedentsTiledMenuHeader isProxy />
          </div>
        </div>
      )
    case SEARCH:
      switch (searchType) {
        case 'qa':
          return <FlavourTabs isProxy isSearch flavours={get(pageParameters, 'qa.flavours', [])} />
        case 'ca':
          return <div className='min-h3 mt4 mb8-m' />
        default:
          break
      }
      return null
    default :
      return null
  }
}

export default HeaderAppendProxy
